import { render, staticRenderFns } from "./ModalVisualizacao.vue?vue&type=template&id=3a3e3f3d&lang=pug"
import script from "./ModalVisualizacao.vue?vue&type=script&lang=js"
export * from "./ModalVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizacao.vue?vue&type=style&index=0&id=3a3e3f3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports